export default __webpack_public_path__ + "static/media/pattern-a.9c68bd5d.png";